import { Field, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class HaulerDriverSettings {
  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  aiVoiceExtractionEnabled?: boolean

  @Field(() => Boolean)
  @Prop({ type: Boolean, default: false })
  aiManifestExtractionEnabled?: boolean
}
